<ng-container *ngIf="contact">
  <header>
    <chapps-header [label]="fullName"></chapps-header>
    <i (click)="toggleFavorite()"
       [ngClass]="contact.favorite ? 'fa-star' : 'fa-star-o'"
       class="fa favorite"
       role="button"></i>

    <i *ngIf="!canDelete"
       [matTooltip]="Localization.DeleteContactFailedDueToExistingLinkedInterventionTeams | translate"
       class="fa fa-question-circle grey-text fa-lg"></i>
    <chapps-danger-button (click)="confirmDelete()"
                          [disabled]="!canDelete"
                          [label]="Localization.Delete | translate"
                          [small]="true"></chapps-danger-button>
  </header>
  <section class="general-info">
    <ul class="profile">
      <li><i class="fas fa-envelope"></i>
        <a [attr.href]="'mailto:'+contact.email">{{ contact.email }}</a>
      </li>
      <li><i class="fas fa-phone"></i> {{ contact.telephone }}</li>
      <li><i class="fas fa-user"></i>{{ contact.gender }}</li>
      <li><i class="fas fa-language"></i>{{ ('languageType_' + contact.language) | translate }}</li>
      <li><i class="fas fa-users"></i>{{ contact.company }}</li>
      <li><i class="fas fa-id-card"></i>{{ contact.nationalRegistrationNumber }}</li>
      <li><i class="fas fa-gift"></i>
        <ng-container *ngIf="contact.birthday">
          {{ dateOfBirth | date: config.DATE_FORMAT }}
        </ng-container>
      </li>
    </ul>

    <chapps-primary-button (click)="edit()"
                           [label]="Localization.EditInfo"
                           [outline]="true"
                           [small]="true"
                           icon="fa-edit"></chapps-primary-button>
  </section>

  <section class="teams">
    <chapps-sub-header [label]="Localization.InterventionTeams"></chapps-sub-header>
    <table class="table table-striped table-hover details-table">
      <thead>
      <tr>
        <th>{{ Localization.TeamName | translate}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let team of teams">
        <td>{{ team.label }}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </section>
</ng-container>
<div
  *ngIf="loading"
  class="page-spinner"
>
  <mdb-spinner spinnerColor="blue" spinnerType="big"></mdb-spinner>
</div>
